<template>
  <v-app>
    <v-main>
      <v-container class="pa-2">
        <div id="backtester-page">
          <helpers-page-header
            header="Backtester"
            text="Use the WhaleWisdom Backtester tool to test how a hypothetical portfolio would have performed with different investment strategies.
                      Research one or more filers performance and then optimize their portfolios to match your own investment goals.
                      Test how a hypothetical portfolio would have performed with different investment strategies.
                      Research one or more filers performance and then optimize their portfolios to match your own investment goals."
          />

          <!-- Run backtest button -->
         <v-row my-2>
                    <v-col cols="12">
            <v-btn
              :disabled="loading || !validCriteria"
              color="primary"
              class="mx-0"
              @click="runBacktest()"
            >
              Run Backtest
            </v-btn>
            </v-col>
          </v-row>

          <v-card
            ma-1
            pa-1
          >
            <v-tabs background-color="grey lighten-4">
              <v-tab
                v-for="tab in tabs"
                :key="tab.header"
              >
                {{ tab.header }}
              </v-tab>
              <v-tab-item
                v-for="tab in tabs"
                :key="tab.header"
              >
                <v-card>
                  <v-card-text>
                    <component :is="tab.component" />
                  </v-card-text>
                </v-card>
              </v-tab-item>
            </v-tabs>
          </v-card>

          <!-- Results -->
          <div id="results-scroll" />
          <helpers-section-header
            id="results-header"
            ref="results-header"
          >
            Backtest results
          </helpers-section-header>
          <backtest-results ref="backtestResults" />

          <!-- Dialog: Loading progress -->
          <v-dialog
            v-model="loading"
            persistent
            width="300"
          >
            <v-card
              color="primary"
              dark
            >
              <v-card-text class="text-body-2">
                Backtest running...
                <v-progress-linear
                  indeterminate
                  color="accent"
                  class="mb-0"
                />
              </v-card-text>
            </v-card>
          </v-dialog>
        </div>
      </v-container>
      <v-snackbar
        v-model="error_snackbar"
      >
        {{ error.text }}
        <v-btn
          color="pink"
          text
          @click="error = false"
        >
          Close
        </v-btn>
      </v-snackbar>
    </v-main>
  </v-app>
</template>

<script>
// Modules
import api from '@/store/api'
import { mapState, mapGetters } from 'vuex'
import { mapFields } from 'vuex-map-fields'
import cloneDeep from 'lodash/cloneDeep'

// Mixins
import AccessMixin from '@/mixins/access'

// Components
import BasicOptions from '@/components/page/backtester/_BasicOptions'
import AdvancedOptions from '@/components/page/backtester/_AdvancedOptions'
import StockFilters from '@/components/page/backtester/_StockFilters'
import BacktestResults from '@/components/page/backtester/_Results'

// Static data
import { defaultBacktesterCriteria } from '@/data/constants'

export default {
  components: {
    BasicOptions,
    AdvancedOptions,
    StockFilters,
    BacktestResults
  },
  mixins: [],
  data: () => ({
    error_snackbar: false,
    error: { text: '' },
    results: null,
    loading: false,
    tabs: [
      {
        header: 'Basic',
        component: BasicOptions
      },
      {
        header: 'Stock Filters',
        component: StockFilters
      },
      {
        header: 'Advanced',
        component: AdvancedOptions
      }
    ]
  }),

  computed: {
    ...mapFields({
      backtesterCriteria: 'app.backtesterCriteria'
    }),
    ...mapState({
      selectedGroup: state => state.app.selectedGroup,
      quarters: state => state.ww.quarters.unshift({ id: 0, description: 'All Available Dates' }),
      groups: state => state.user.groups
    }),
    ...mapGetters({
      subscription: 'user/subscription'
    }),

    validCriteria () {
      return (

        this.selectedGroup.filers.length > 0
      )
    }
  },

  watch: {

  },

  mounted () {
  },

  created () {
    this.selectedGroup.filers.push({ 'id': window.whalewisdom.Filer.filer_id,
      'name': '' })
    this.backtesterCriteria.quarter_one = this.quarters[5]
    this.backtesterCriteria.quarter_two = this.$store.getters['ww/currentQuarter']

    // Init with defaults
    this.backtesterCriteria = cloneDeep(defaultBacktesterCriteria)
  },

  methods: {
    runBacktest () {
      this.loading = true
      this.results = null
      this.backtesterCriteria.filers = [{ 'id': window.whalewisdom.Filer.filer_id,
        'name': '' }]// this.selectedGroup.filers
      this.backtesterCriteria.filer_group_id = this.selectedGroup.id

      api
        .post('run_backtest', this.backtesterCriteria)
        .then(res => {
          this.results = res.data
          this.$refs.backtestResults.genResults(this.results)

          // Send the Event info to GA
          // let usertype = this.$store.getters['user/subscription'] || 'Not logged in'
          // this.$ga.event('backtest', 'filer', usertype)
        })
        .then(() => {
          //  $("html, body").animate({ scrollTop: $('#results-header').offset().top }, 1000);
          this.$vuetify.goTo('#results-header', { offset: 20, duration: 2000 })
        })
        .catch(error => {
          this.error_snackbar = true
          this.error = { type: 'error', text: (error.response && error.response.data) || error.message }
          //  this.$store.commit('app/NOTIFICATION', { type: 'error', text: (error.response && error.response.data) || error.message })
        })
        .then(() => (this.loading = false))
    },

    // TODO (server-side): This whole thing should be reworked and simplifed
    // Would require changes to the API
    syncCriteriaSettings (settings) {
      // Reference the Fund Perf dialog component
      // to be able to access its data items
      let fundPerf = this.$refs.FundPerformanceDialog
      let criteria = this.backtesterCriteria

      /**
                  * Merge the settings
                  */

      // Predefined
      criteria.whalescore = this.whalescoreFilersItems.find(item => item.value === parseInt(settings.whalescore))
      if (settings.filer_performance_selected) {
        criteria.filer_performance.selected = settings.filer_performance_selected
        criteria.filer_performance.top_performing_type =
                     fundPerf.topPerformingTypes.find(item => item.value === settings.filer_performance_top_performing_type_id)
        criteria.filer_performance.max_filers = settings.filer_performance_max_filers
        criteria.filer_performance.adv_insider_ownership = settings.filer_performance_adv_insider_ownership
        criteria.filer_performance.turnover_type =
                     fundPerf.turnoverChoices.find(item => item.value === settings.filer_performance_turnover_type_id)
        criteria.filer_performance.top10_type =
                     fundPerf.top10Choices.find(item => item.value === settings.filer_performance_top10_type_id)
        criteria.filer_performance.use_holdings = settings.filer_performance_use_holdings
        criteria.filer_performance.holdings_from_to = settings.filer_performance_holdings_from_to
        criteria.filer_performance.use_mc = settings.filer_performance_use_mc
        criteria.filer_performance.mc_from_to = settings.filer_performance_mc_from_to
      }
      if (settings.whalescore === 0 && !settings.filer_group_id) {
        this.$store.commit('app/SET_SELECTED_GROUP', {
          id: null,
          description: 'New Group',
          visibility_type_id: 0,
          filers: [...settings.filers]
        })
      } else if (settings.filer_group_id) {
        let group = this.groups.find(g => g.id === settings.filer_group_id)
        this.$store.commit('app/SET_SELECTED_GROUP', group)
      }

      // Basic
      criteria.stock_selection_group = settings.stock_selection
      criteria.stock_selection_top_ranking = settings.stock_selection_top_ranking
      criteria.stock_weight_group = settings.weight_selection
      criteria.holdings = settings.number_of_holdings
      criteria.backtesting_days = settings.backtesting_days
      criteria.no_rebalancing = settings.no_rebalancing
      if (settings.consensus_min_percent_portfolio) {
        criteria.consensus_min_percent_portfolio = parseFloat(settings.consensus_min_percent_portfolio)
      }
      if (settings.consensus_min_filers) {
        criteria.consensus_min_filers = parseInt(settings.consensus_min_filers)
      }

      // Stock
      // TODO (server-side): change the id to be an integer instead of a string
      criteria.market_caps = settings.stock_market_caps.map(cap => ({
        ...cap,
        id: parseInt(cap.id)
      }))
      criteria.sectors = this.$store.state.ww.sectors.filter(item => settings.sectors.some(sector => parseInt(sector.id) === item.id))
      criteria.exclusion_tickers = settings.exclusion_tickers.join()
      criteria.exclusion_more_than = settings.exclusion_more_than
      criteria.exclusion_less_than = settings.exclusion_less_than
      criteria.exclude_etf = settings.exclude_etf
      criteria.exclude_adr = settings.exclude_adr

      // Advanced
      criteria.backtesting_days_submitted = settings.rebalance_when_submitted
      if (settings.double_down_selected) {
        criteria.double_down = {
          check_for_13d: settings.double_down_check_for_13d,
          percent_decline: settings.double_down_percent_decline,
          percent_increase: settings.double_down_percent_increase,
          percent_of_portfolio: settings.double_down_percent_of_portfolio,
          purchase_percent: settings.double_down_purchase_percent,
          selected: settings.double_down_selected,
          stdev_decline: settings.double_down_stdev_decline
        }
      }
      criteria.stop_loss_enabled = settings.stop_loss_enabled
      criteria.stop_loss_decline_from_purchase = settings.stop_loss_decline_from_purchase
      criteria.stop_loss_increase_from_purchase = settings.stop_loss_increase_from_purchase
      criteria.hedging_type = settings.hedging_type
      criteria.hedging_percentage = settings.hedging_percentage
      criteria.hedge_moving_average_target = settings.hedge_moving_average_target
      criteria.hedging_moving_average_months = settings.hedging_moving_average_months
      criteria.rebalance_frequency = settings.rebalance_frequency
      criteria.sell_buffer_threshold = settings.sell_buffer_threshold
      if (settings.earliest_quarter && settings.earliest_quarter > 1) {
        criteria.earliest_quarter = settings.earliest_quarter
      }
      if (settings.ending_quarter && settings.ending_quarter > 1) {
        criteria.ending_quarter = settings.ending_quarter
      }
    },

    resetBacktesterOptions () {
      if (!window.confirm('Are you sure you want to reset your current backtester options?')) {
        return
      }

      this.backtesterCriteria = cloneDeep(defaultBacktesterCriteria)

      this.$store.commit('app/SET_SELECTED_GROUP', null)
    }

  }
}

</script>

<style>
</style>

<style lang="scss">
@import '~@vars';
@import '~@/assets/style/main';

#nprogress .bar {
  background: $primary;
}

.v-list .v-list-item--active, .v-list .v-list-item--active .v-icon {color:#66c6ba !important}

.v-window {
     overflow: visible !important;
}
</style>
